// Passkey/WebAuthn LiveView-Hooks. Schlank: die Ceremony läuft über zwei
// fetch-Aufrufe (Challenge holen, Antwort verifizieren), der Server hält Zustand.

const b64uToBuf = (s) => {
  const b64 = s.replace(/-/g, "+").replace(/_/g, "/")
  const bin = atob(b64 + "=".repeat((4 - (b64.length % 4)) % 4))
  const buf = new Uint8Array(bin.length)
  for (let i = 0; i < bin.length; i++) buf[i] = bin.charCodeAt(i)
  return buf.buffer
}

const bufToB64u = (buf) => {
  const bytes = new Uint8Array(buf)
  let bin = ""
  for (let i = 0; i < bytes.length; i++) bin += String.fromCharCode(bytes[i])
  return btoa(bin).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "")
}

const post = (url, body) =>
  fetch(url, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "accept": "application/json",
      "x-csrf-token": document.querySelector("meta[name='csrf-token']").getAttribute("content"),
    },
    body: JSON.stringify(body || {}),
  })

// Fehlermeldung in die aria-live-Region schreiben (data-error-el verweist per id).
const errorSink = (el) => {
  const target = el.dataset.errorEl && document.getElementById(el.dataset.errorEl)
  return (msg) => target && (target.textContent = msg)
}

const run = async (el, fn) => {
  const setError = errorSink(el)
  setError("")
  el.disabled = true
  try {
    if (!window.PublicKeyCredential) throw new Error(el.dataset.unsupportedText)
    await fn()
  } catch (e) {
    setError(e.message || el.dataset.errorText)
    el.disabled = false
  }
}

export const PasskeyRegister = {
  mounted() {
    this.el.addEventListener("click", () =>
      run(this.el, async () => {
        const optRes = await post("/webauthn/register/options")
        if (!optRes.ok) throw new Error()
        const opts = await optRes.json()
        opts.challenge = b64uToBuf(opts.challenge)
        opts.user.id = b64uToBuf(opts.user.id)
        opts.excludeCredentials = (opts.excludeCredentials || []).map((c) => ({...c, id: b64uToBuf(c.id)}))

        const cred = await navigator.credentials.create({publicKey: opts})
        const labelEl = this.el.dataset.labelEl && document.getElementById(this.el.dataset.labelEl)
        const res = await post("/webauthn/register", {
          attestationObject: bufToB64u(cred.response.attestationObject),
          clientDataJSON: bufToB64u(cred.response.clientDataJSON),
          transports: cred.response.getTransports ? cred.response.getTransports() : [],
          label: (labelEl && labelEl.value.trim()) || null,
        })
        if (!res.ok) throw new Error((await res.json().catch(() => ({}))).error)
        window.location.reload()
      }))
  },
}

export const PasskeyAuthenticate = {
  mounted() {
    this.el.addEventListener("click", () =>
      run(this.el, async () => {
        const optRes = await post("/webauthn/authenticate/options")
        if (!optRes.ok) throw new Error()
        const opts = await optRes.json()
        opts.challenge = b64uToBuf(opts.challenge)
        opts.allowCredentials = (opts.allowCredentials || []).map((c) => ({...c, id: b64uToBuf(c.id)}))

        const assertion = await navigator.credentials.get({publicKey: opts})
        const res = await post("/webauthn/authenticate", {
          rawId: bufToB64u(assertion.rawId),
          authenticatorData: bufToB64u(assertion.response.authenticatorData),
          clientDataJSON: bufToB64u(assertion.response.clientDataJSON),
          signature: bufToB64u(assertion.response.signature),
          userHandle: assertion.response.userHandle ? bufToB64u(assertion.response.userHandle) : null,
        })
        const json = await res.json().catch(() => ({}))
        if (!res.ok) throw new Error(json.error)
        window.location = json.redirect || "/pets"
      }))
  },
}
